import { defineQuery, useQuery } from "@pinia/colada";

export const useMyOrders = defineQuery(() => {
  const params = ref<PaginationParams>({ page: 1, per_page: 10 });
  const { data: myOrders, isLoading, status, error } = useQuery<MyOrders, Error, MyOrders>({
    key: () => ["blog", { ...params.value }],
    query: async () => v.parse(myOrdersSchema, await ajaxRequest<MyOrders>("get_my_orders", params.value)),
    placeholderData: { orders: [], orders_total: 0 },
    staleTime: 1000 * 60 * 60 * 24,
  });
  return { params, myOrders, isLoading, status, error };
});
